/* WPS Pages Application JavaScript */
import Alpine from 'alpinejs'

// Import Stimulus controllers
import '../controllers'

// Import editor functions FIRST (before Alpine starts)
// This ensures editorTemplatesWithCategories is available globally
import './editor'
import { loadPageContent } from './page_loader'
import { initFormRating } from './form_rating'
import { initFormOther } from './form_other'
import { initFormConditional } from './form_conditional'
import { initPlanManagerTypeahead } from './plan_manager_typeahead'
import { initFormParticipants } from './form_participants'
import { initTurnstile } from './turnstile'
import { AIHelper } from './ai_helper'
import { aiChat } from './ai_chat'
import { tagTypeahead } from './tag_typeahead'
import { cssClassTypeahead } from './css_class_typeahead'

// Registers window.openMediaLibraryPicker (used by template "image" property controls)
import '../alpineblocks/plugins/MediaLibraryPicker'

// Make Alpine global for AlpineBlocks
window.Alpine = Alpine

// "Other" free-text option toggles — initialize immediately at bundle load so the global change
// listener is registered independent of the Alpine/AlpineBlocks init path (which can stall on
// non-admin layouts and otherwise prevent this module from ever initializing).
initFormOther()
document.addEventListener('turbo:load', initFormOther)

// Conditional field show/hide — same reasoning as above: register at bundle
// load rather than inside init().
initFormConditional()
document.addEventListener('turbo:load', initFormConditional)
document.addEventListener('turbo:frame-load', initFormConditional)

// Plan manager type-ahead — same reasoning again: registered at bundle load so
// it works on the public (non-admin) layout.
initPlanManagerTypeahead()
document.addEventListener('turbo:load', initPlanManagerTypeahead)
document.addEventListener('turbo:frame-load', initPlanManagerTypeahead)

// Participants repeater rows — same reasoning again.
initFormParticipants()
document.addEventListener('turbo:load', initFormParticipants)
document.addEventListener('turbo:frame-load', initFormParticipants)

// Cloudflare Turnstile explicit render — must also run on turbo:frame-load, as
// a form re-rendered after a validation error carries a brand new widget div.
initTurnstile()
document.addEventListener('turbo:load', initTurnstile)
document.addEventListener('turbo:frame-load', initTurnstile)

async function init() {

    // Make sure Alpine is globally available before importing AlpineBlocks
    // (AlpineBlocks checks for window.Alpine at import time)

    // Import AlpineBlocks (now that window.Alpine exists)
    await import('../alpineblocks')

    // Register custom Alpine components before Alpine.start()
    Alpine.data('tagTypeahead', tagTypeahead)
    Alpine.data('cssClassTypeahead', cssClassTypeahead)

    // Configure AlpineBlocks layouts BEFORE Alpine.start()
    if (window.AlpineBlocks) {
        window.AlpineBlocks.configure({
            layouts: {
                source: 'remote',
                url: '/admin/templates/',
                index: 'index_json'
            }
        });
    }

    // Add hook to load initial blocks after editor is initialized
    document.addEventListener('alpine:initialized', () => {
        setTimeout(() => {
            const editorElement = document.querySelector('#alpineblocks-editor[data-initial-blocks]');
            if (editorElement) {
                const initialBlocks = editorElement.dataset.initialBlocks;
                if (initialBlocks && initialBlocks !== '[]') {
                    // Use the loadPageContent function
                    loadPageContent(editorElement, initialBlocks);
                }
            }
        }, 500); // Small delay to ensure editor is fully initialized
    });

    // Initialize form rating components
    document.addEventListener('turbo:load', initFormRating);
    document.addEventListener('alpine:initialized', initFormRating);

    // Initialize AI helper for page metadata fields
    document.addEventListener('alpine:initialized', () => {
        setTimeout(() => {
            if (document.getElementById('page_meta_title')) {
                const aiHelper = new AIHelper();
                aiHelper.initialize();
                window.aiHelperInstance = aiHelper;
            }
        }, 600); // Slight delay after Alpine is fully ready
    });

    // Start Alpine after AlpineBlocks has registered its components AND been configured
    if (!window.Alpine?._started) {
        Alpine.start()
    }
}

init()

// Make AI Chat available globally
window.aiChat = aiChat

// Export for use in other modules
export { Alpine, loadPageContent, aiChat }